import type { ICartItem } from './invoicing.service';

/**
 * True when at least one cart line has a unit price above 0.
 * Discounts that bring the net total to 0 do not count as a zero amount.
 */
export function saleLinesHaveNonZeroUnitPrice(saleLines?: ICartItem[] | null): boolean {
    return (saleLines ?? []).some((line) => Number(line.unitPriceCents || 0) > 0);
}
